import {useContext, useEffect, useState} from "react";
import html2canvas from "html2canvas";
import ThemeContext from "../Theme/ThemeContext";
import Network from "../Util/Network";
import {GameHint} from "../../Quiz/Components/GameHint";
import Footer from "./Footer";
import Score, {ScoreData} from "./Score";

interface DiplomaProps {
    score : ScoreData
    scoreBackground? : string
    title : string
    text : string
    name : string
    pageTitleElement? : JSX.Element
    onCancel: () => void
}

export function Diploma(props : DiplomaProps) {

    const [state, setState] = useState({ loading: true, qrCodeUrl: "" } )
    const [diplomaVisible, setDiplomaVisible] = useState<boolean>(false)

    const theme = useContext(ThemeContext)

    useEffect(() => {
        if (diplomaVisible) {

            const container = document.createElement('div')
            const div = document.querySelector('#diplomaView') as HTMLElement
            const cloned = div.cloneNode(true) as HTMLElement

            container.style.position = 'absolute'
            container.style.left = '200vw'
            container.style.height = '0px'
            container.style.overflow = 'hidden'

            cloned.classList.add('screenshot')

            container.appendChild(cloned)
            div.parentNode.appendChild(container)

            html2canvas(cloned, {scale: 1, logging: false}).then(canvas => {
                container.remove()
                canvas.toBlob(function (blob) {
                    Network.sendDiploma(blob, function (data) {
                        setState({loading: false, qrCodeUrl: data.qrUrl})
                    })
                }, 'image/jpg', 1)
            })
        }
    }, [diplomaVisible])

    return <div className="game-diploma" style={{backgroundImage:'url('+theme.backgroundImage+')'}}>
        { props.pageTitleElement ? props.pageTitleElement : <h1>{props.title}</h1> }
        <GameHint text={"Dyplom możesz pobrać skanując kod QR"}/>
        <div className="wrapper">
            <div id="diplomaView" className={diplomaVisible ? "diploma-view" : "diploma-view hidden"}>
                <img src={theme.diplomaImage} alt="Dyplom" onLoad={() => { setDiplomaVisible(true)}}/>
                <div className="text">
                    <p>dla</p>
                    <p className="name">{props.name}</p>
                    <p>{props.text}</p>

                    { props.score.type === "points" ?
                        <p><span className="score">{props.score.score} na {props.score.scoreMax}</span> punktów</p>
                        :
                        ( props.score.type == "time" ? <p className="score">{props.score.time} s</p> : <></>)
                    }
                </div>
            </div>
            <div className="qr-code">
                <img src={state.qrCodeUrl} alt="qr"/>
                <div className={state.loading ? "loading" : "loading hidden"}></div>
            </div>
        </div>
        <Score data={props.score} backgroundImage={props.scoreBackground}/>
        <Footer home={props.onCancel}/>
    </div>
}